import React, { Component } from 'react';
import temp from '../../../Images/Daikin_Images/icon/temp.png';
import error from '../../../Images/Cell_Status_Icon/error.png';
import Chart_Gauge from '../../Part_Sample/Chart_Gauge';

export default class Site_Cell extends Component {
	constructor(props) {
		super(props);

		this.state = {
			is_cell_focused: false,
		}
	}

	handleSelectSite = () => {
		if (this.props.site_info.stat.connection) {
			window.app.content_area.current.switch_content.current.handleHideBottomMenu();
			window.app.content_area.current.content_handler('MSM_Transition_Screen', { site_id: this.props.site_id, is_msm_mode: false });
		}
	}

	render() {
		let style = {
			display: 'flex',
			verticalAlign: 'top'
		}

		let cell_width = 180;
		if (this.props.is_narrow_screen) cell_width = this.props.width - 30; //If cannot hold 2 or more cells in 1 line then full width

		let background_color = this.props.colours.appBlue;
		if (!this.props.site_info.stat.connection) background_color = '#b2b2b2ad';

		let cell_style = {
			cursor: 'pointer',
			width: cell_width,
			margin: 5,
			padding: 10,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			borderRadius: 20,
			cursor: 'pointer',
			backgroundColor: background_color,
			textAlign: this.props.is_narrow_screen ? 'center' : 'left'
		}

		let is_show_ac = false;
		let is_show_sp = false;
		let is_show_energy = false;
		if (this.props.site_info.stat.ac != null) {
			if (this.props.site_info.stat.ac.length > 0) is_show_ac = true;
		}

		if (this.props.site_info.stat.sp != null) {
			if (this.props.site_info.stat.sp.length > 0) {
				if (this.props.site_info.stat.sp[0] != null && this.props.site_info.stat.sp[1] != null) {
					is_show_sp = true;
				}
			}
		}

		let today_energy = 0;
		let this_month_energy = 0;

		if (this.props.site_info.stat.energy != null) {
			if (this.props.site_info.stat.energy.length > 0) {
				is_show_energy = true;
				if (this.props.site_info.attr.size != null && this.props.site_info.attr.size != 0) {
					today_energy = (this.props.site_info.stat.energy[0] / this.props.site_info.attr.size).toFixed(2);
					this_month_energy = (this.props.site_info.stat.energy[1] / this.props.site_info.attr.size).toFixed(2);
				}
			}
		}

		return (
			<div style={style} className={this.state.is_cell_focused ? 'flipOutY' : 'flipInY'}>
				<div style={cell_style} onClick={this.handleSelectSite}>
					<div id={this.props.site_id + '_content'}>
						<div style={{ display: this.props.is_narrow_screen ? 'inline-block' : 'block', textAlign: 'left', width: this.props.is_narrow_screen ? '50%' : 'unset' }}>
							<div>
								<span className='header' style={{ fontSize: 16, color: 'white' }}>{this.props.site_info.attr.name}</span>
							</div>
							<div>
								<span style={{ color: 'white', fontSize: 12, verticalAlign: this.props.is_narrow_screen ? 'unset' : 'top' }}>{this.props.site_info.attr.location}</span>
							</div>
						</div>
						<div style={{ backgroundColor: this.props.is_narrow_screen ? 'unset' : 'white', display: this.props.is_narrow_screen ? 'inline-block' : 'block', color: this.props.is_narrow_screen ? 'white' : 'black', textAlign: this.props.is_narrow_screen ? 'right' : 'left', width: this.props.is_narrow_screen ? '50%' : 'unset' }}>
							<div>
								<div style={{ display: 'inline-block', verticalAlign: 'top', paddingTop: 5 }}>
									<span style={{ fontSize: 12 }}>{this.props.receiver.getString('floor_area') + ': '}</span>
								</div>
								<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 5 }}>
									<span className='header' style={{ fontFamily: 'unset', fontSize: 16, color: this.props.is_narrow_screen ? 'white' : 'black' }}>{this.props.site_info.attr.size + 'm²'}</span>
								</div>
							</div>
							<div>
								<div style={{ display: is_show_ac ? 'block' : 'none' }}>
									<div style={{ display: 'inline-block', verticalAlign: 'top', paddingTop: 5 }}>
										<span style={{ fontSize: 12 }}>{this.props.receiver.getString('operational_ac') + ':'}</span>
									</div>
									<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 5 }}>
										<span className='header' style={{ fontFamily: 'unset', fontSize: 16, color: this.props.is_narrow_screen ? 'white' : 'black' }}>{this.props.site_info.stat.ac[0] + '/' + this.props.site_info.stat.ac[1]}</span>
									</div>
								</div>
							</div>
						</div>

						<div style={{ display: is_show_sp ? 'block' : 'none', backgroundColor: 'white' }}>
							<div style={{ display: 'inline-block', verticalAlign: 'top', paddingTop: 5 }}>
								<span style={{ fontSize: 12 }}>{this.props.receiver.getString('sp') + ':'}</span>
							</div>
							<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 5 }}>
								<span className='header' style={{ fontSize: 16, fontFamily: 'unset', }}>{this.props.site_info.stat.sp[0] + '-' + this.props.site_info.stat.sp[1] + ' ' + this.props.receiver.getString('DEG')}</span>
							</div>
						</div>

						<div style={{ backgroundColor: 'white' }}>
							<div style={{ width: this.props.is_narrow_screen ? '25%' : '50%', height: 25, verticalAlign: 'top', display: this.props.site_info.stat.value != null ? 'inline-block' : 'none', backgroundColor: 'white', textAlign: 'center' }}>
								<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
									<span style={{ fontSize: 16 }}>{this.props.site_info.stat.value}</span>
								</div>
								<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 5 }}>
									<span style={{ fontSize: 16 }}>{this.props.site_info.stat.val_unit}</span>
								</div>
							</div>
							<div style={{ width: this.props.is_narrow_screen ? '25%' : '50%', height: 25, verticalAlign: 'top', display: this.props.site_info.stat.temp != null ? 'inline-block' : 'none', backgroundColor: 'white', textAlign: 'center' }}>
								<div style={{ marginLeft: -5, display: 'inline-block' }}>
									<img src={temp} style={{ width: 20 }} />
								</div>
								<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
									<span style={{ fontSize: 16 }}>{this.props.site_info.stat.temp}</span>
								</div>
							</div>
						</div>

						<div style={{ display: is_show_energy ? 'block' : 'none', backgroundColor: 'white' }}>
							<div>
								<span className='header' style={{ fontFamily: 'unset', fontSize: 14 }}>{this.props.receiver.getString('energy_consumption') + '/m²'}</span>
							</div>
							<div className='header' style={{ fontSize: 12 }}>
								<div style={{ display: 'inline-block', verticalAlign: 'top', paddingTop: 5 }}>
									<span style={{ fontFamily: 'unset', fontSize: 12 }}>{this.props.receiver.getString('today') + ':'}</span>
								</div>
								<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 5 }}>
									<span style={{ fontFamily: 'unset', fontSize: 16 }}>{today_energy + ' kWh/m²'}</span>
								</div>
							</div>
							<div className='header' style={{ fontSize: 12 }}>
								<div style={{ display: 'inline-block', verticalAlign: 'top', paddingTop: 5 }}>
									<span style={{ fontFamily: 'unset', fontSize: 12 }}>{this.props.receiver.getString('this_month') + ':'}</span>
								</div>
								<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 5 }}>
									<span style={{ fontFamily: 'unset', fontSize: 16 }}>{this_month_energy + ' kWh/m²'}</span>
								</div>
							</div>
						</div>
						<div style={{ display: this.props.site_info.stat.error || this.props.site_info.stat.alert ? 'block' : 'none', backgroundColor: 'white' }}>
							<img src={error} style={{ cursor: 'pointer', width: 25 }} />
						</div>
					</div>
					<div style={{ flexGrow: 1, backgroundColor: 'white' }}>

					</div>
				</div>
			</div>
		)
	}
}